'use client';

import React from 'react';
import * as HoverCard from '@radix-ui/react-hover-card';

type HoverCardProps = {
  id: string;
  triggerContent: React.ReactNode;
  content: React.ReactNode;
};

export function DMHoverCard({ id, triggerContent, content }: HoverCardProps) {
  return (
    <HoverCard.Root openDelay={0}>
      <HoverCard.Trigger asChild>{triggerContent}</HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          className='data-[side=bottom]:animate-slideUpAndFade data-[side=right]:animate-slideLeftAndFade data-[side=left]:animate-slideRightAndFade data-[side=top]:animate-slideDownAndFade w-[300px] rounded-md bg-brand-secondary border border-slate-700 p-3 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] data-[state=open]:transition-all z-50'
          sideOffset={5}
        >
          {content}
          <HoverCard.Arrow className='fill-slate-500' />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
}
